import React, { useState, useEffect } from 'react';
import { Search, Menu, X } from 'lucide-react';
import './Deals.css';
import logo from '../components/assets/logo.png';
import { useNavigate } from "react-router-dom";

const Deals = () => {
  const navigate = useNavigate();
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile && !sidebarVisible) {
        // Reset sidebar visibility on desktop
        setSidebarVisible(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [sidebarVisible]);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  const closeSidebar = () => {
    if (isMobile) {
      setSidebarVisible(false);
    }
  };

  const orders = [
    { id: 'ORD001', user: 'Sarah Eastern', status: 'COMPLETED', date: '2023/09/7', progress: 'In Progress' },
    { id: 'ORD002', user: 'John Smith', status: 'COMPLETED', date: '2023/09/8', progress: 'Completed' },
    { id: 'ORD003', user: 'Emma Wilson', status: 'PENDING', date: '2023/09/9', progress: 'In Progress' },
    { id: 'ORD004', user: 'Michael Brown', status: 'COMPLETED', date: '2023/09/10', progress: 'In Progress' },
    { id: 'ORD005', user: 'Lisa Davis', status: 'ONGOING', date: '2023/09/11', progress: 'In Progress' },
    { id: 'ORD006', user: 'David Miller', status: 'COMPLETED', date: '2023/09/12', progress: 'In Progress' },
  ];

  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  return (
    <div className="deals-container">
      {/* Toggle Button */}
      <button 
        className={`deals-toggle-btn ${!sidebarVisible ? 'active' : ''}`}
        onClick={toggleSidebar}
      >
        <div className="deals-toggle-icon">
          {sidebarVisible ? <Menu size={20} /> : <X size={20} />}
        </div>
      </button>

      {/* Overlay for mobile */}
      {isMobile && sidebarVisible && (
        <div className="deals-overlay active" onClick={closeSidebar}></div>
      )}

      {/* Sidebar */}
      <aside className={`deals-sidebar ${
        isMobile 
          ? (sidebarVisible ? 'show' : '') 
          : (sidebarVisible ? '' : 'hidden')
      }`}>
        <img src={logo} alt="LitStudio" className="deals-logo" />
        <nav>
          <ul className="deals-nav">
            <li className="deals-nav-item" onClick={() => {
              navigate("/Dashboard");
              closeSidebar();
            }}>
              📊 Dashboard
            </li>
            <li className="deals-nav-item deals-nav-item--active" onClick={() => {
              navigate("/Deals");
              closeSidebar();
            }}>
              💼 Deals
            </li>
            <li className="deals-nav-item" onClick={() => {
              navigate("/Upload");
              closeSidebar();
            }}>
              📤 Upload
            </li>
            <li className="deals-nav-item" onClick={() => {
              navigate("/Schedule");
              closeSidebar();
            }}>
              📅 Schedule
            </li>
            <li className="deals-nav-item" onClick={() => {
              navigate("/MemberShip");
              closeSidebar();
            }}>
              👑 Membership Plan
            </li>
          </ul>
        </nav>
        <div className="deals-user-section">
          <div className="deals-user-info">
            <div className="deals-avatar">🚀</div>
            <div className="deals-welcome-text">
              <div style={{ fontSize: '0.875rem', fontWeight: '500' }}>Welcome back 👋</div>
              <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '2px' }}>Bula Studios</div>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className={`deals-main-content ${
        !sidebarVisible && !isMobile ? 'expanded' : ''
      }`}>
        <h1 className="deals-title" style={{ 
          fontSize: '2rem', 
          fontWeight: '700', 
          marginBottom: '2rem',
          background: 'linear-gradient(135deg, #ff4d4d 0%, #ff6b6b 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          Deals Management
        </h1>
        
        <div className="deals-stats-container">
          <div className="deals-stat-card">
            <div className="deals-stat-title" style={{ 
              fontSize: '0.875rem', 
              fontWeight: '500', 
              color: '#666',
              marginBottom: '0.5rem'
            }}>
              Categories Listed
            </div>
            <div className="deals-stat-value">3</div>
          </div>
          
          <div className="deals-orders-stats">
            <div className="deals-stat-group">
              <div className="deals-stat-value">62</div>
              <div className="deals-stat-label">Orders</div>
            </div>
            <div className="deals-stat-group">
              <div className="deals-stat-value">6</div>
              <div className="deals-stat-label">Pending</div>
            </div>
            <div className="deals-stat-group">
              <div className="deals-stat-value">56</div>
              <div className="deals-stat-label">Completed</div>
            </div>
            <div className="deals-stat-group">
              <div className="deals-stat-value">0</div>
              <div className="deals-stat-label">Cancelled</div>
            </div>
          </div>
        </div>

        <div className="deals-actions-bar">
          <button className="deals-filter-btn">
            🔍 Filter
          </button>
          <div className="deals-search-bar">
            <Search size={18} style={{ color: '#ff4d4d' }} />
            <input 
              type="text" 
              placeholder="Search orders, users, or status..." 
              className="deals-search-input" 
            />
          </div>
          <div className="deals-right-actions">
            <button className="deals-next-btn">
              ➡️ Next
            </button>
            <button className="deals-new-order-btn">
              ➕ New Order
            </button>
          </div>
        </div>

        <div className="deals-table-container">
          <table className="deals-table">
            <thead className="deals-table-header">
              <tr>
                <th className="deals-table-head">Order ID</th>
                <th className="deals-table-head">User</th>
                <th className="deals-table-head">Status</th>
                <th className="deals-table-head">Date</th>
                <th className="deals-table-head">Progress</th>
              </tr>
            </thead>
            <tbody className="deals-table-body">
              {orders.map((order, index) => (
                <tr key={index} className="deals-table-row">
                  <td className="deals-table-cell">
                    <span style={{ fontWeight: '600', color: '#ff4d4d' }}>
                      {order.id}
                    </span>
                  </td>
                  <td className="deals-table-cell">
                    <div className="deals-user-cell">
                      <div className="deals-user-avatar">
                        {getInitials(order.user)}
                      </div>
                      <span style={{ fontWeight: '500' }}>
                        {order.user}
                      </span>
                    </div>
                  </td>
                  <td className="deals-table-cell">
                    <span className={`deals-status-badge deals-status-badge--${order.status.toLowerCase()}`}>
                      {order.status === 'COMPLETED' && '✅ '}
                      {order.status === 'PENDING' && '⏳ '}
                      {order.status === 'ONGOING' && '🔄 '}
                      {order.status}
                    </span>
                  </td>
                  <td className="deals-table-cell">
                    <span style={{ color: '#666' }}>
                      {new Date(order.date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      })}
                    </span>
                  </td>
                  <td className="deals-table-cell">
                    <span style={{ 
                      color: order.progress === 'Completed' ? '#008000' : '#ff8c00',
                      fontWeight: '500'
                    }}>
                      {order.progress === 'Completed' && '✅ '}
                      {order.progress === 'In Progress' && '🔄 '}
                      {order.progress}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
};

export default Deals;
